import { formatCurrency } from "@/helpers/formatCurrency.ts";
import { isInquiryPaymentType } from "@/helpers/isInquiryPaymentType.ts";
import { PaymentProviderEnum, PaymentType } from "@/helpers/types/types.ts";
import { PaymentNoteProps } from "@/pages/ReservationOverview/components/PaymentNote/PaymentNoteProps.ts";
import { useRenderCheckReservationOverviewSubmit } from "@/pages/ReservationOverview/components/ReservationOverviewSubmit/hooks/useRenderCheckReservationOverviewSubmit.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { Trans } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const PaymentNote = (props: PaymentNoteProps) => {
  const { paymentEnabled, paymentType } = props;
  const { calculatedCartData } = useEngineStore(
    useShallow((state) => ({
      calculatedCartData: state.calculatedCartData,
    })),
  );
  const { hasAccTypesForPaymentInCart, hasAccTypeCategoriesForPaymentInCart } =
    useRenderCheckReservationOverviewSubmit();

  const shouldShowNote = paymentEnabled && !isInquiryPaymentType(calculatedCartData);

  if (!shouldShowNote) return null;

  const isDownPaymentDifferentThanTotal =
    !!calculatedCartData?.downPaymentAmount &&
    !!calculatedCartData?.priceBreakdown?.withDiscount &&
    calculatedCartData?.downPaymentAmount !== calculatedCartData?.priceBreakdown?.withDiscount;

  if (paymentType === PaymentProviderEnum.WsPay || paymentType === PaymentProviderEnum.WsPayPer) {
    const cartPaymentType = calculatedCartData?.paymentConfig?.paymentType;

    if (cartPaymentType === PaymentType.Payment) {
      if (isDownPaymentDifferentThanTotal) {
        return (
          <>
            <p>
              <Trans
                i18nKey={
                  hasAccTypesForPaymentInCart || hasAccTypeCategoriesForPaymentInCart
                    ? "cardPaymentValueOptionalInNextStep"
                    : "cardPaymentValueInNextStep"
                }
                components={{ b: <strong /> }}
                values={{ amount: formatCurrency(calculatedCartData.downPaymentAmount) }}
              />
            </p>
            <p>
              <Trans i18nKey="remainingPayAmountInfo" />
            </p>
          </>
        );
      }

      return (
        <p>
          <Trans i18nKey="cardPaymentInNextStep" />
        </p>
      );
    }

    if (cartPaymentType === PaymentType.CardGuarantee) {
      return (
        <p>
          <Trans i18nKey="paymentNote" components={{ 1: <br /> }} />
        </p>
      );
    }
  }

  return null;
};
